export const sellerImpactMock = {
  errors: [],
  data: {
    planImpact: [
      {
        offer: {
          id: 9459948857,
          name: 'Access / 80% MS',
          seller: {
            name: 'Wright Medical Technology Inc',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 3,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 2057513,
                spendVolumeBracket: null,
                unitVolume: 2276,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 2057516,
                spendVolumeBracket: null,
                unitVolume: 2276,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 173,
              excludedPlannedSpend: {
                spendVolume: 22850,
                spendVolumeBracket: null,
                unitVolume: 457,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 2034663,
                spendVolumeBracket: null,
                unitVolume: 1819,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 67163,
                spendVolumeBracket: null,
                unitVolume: 64,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 67163,
                spendVolumeBracket: null,
                unitVolume: 64,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 33,
              excludedPlannedSpend: {
                spendVolume: 1200,
                spendVolumeBracket: null,
                unitVolume: 24,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 65963,
                spendVolumeBracket: null,
                unitVolume: 40,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 1051,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 529295,
                spendVolumeBracket: null,
                unitVolume: 621,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 530346,
                spendVolumeBracket: null,
                unitVolume: 621,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 85,
              excludedPlannedSpend: {
                spendVolume: 5450,
                spendVolumeBracket: null,
                unitVolume: 109,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 523845,
                spendVolumeBracket: null,
                unitVolume: 512,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9393580294,
          name: 'Access / Dual Source 90%',
          seller: {
            name: 'Zimmer Biomet',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 9608.5,
              savingsPct: 20,
              plannedSpend: {
                spendVolume: 37735.5,
                spendVolumeBracket: null,
                unitVolume: 106,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 47344,
                spendVolumeBracket: null,
                unitVolume: 106,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 38,
              excludedPlannedSpend: {
                spendVolume: 8126.5,
                spendVolumeBracket: null,
                unitVolume: 67,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 29609,
                spendVolumeBracket: null,
                unitVolume: 39,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 536,
              savingsPct: 8,
              plannedSpend: {
                spendVolume: 5470.5,
                spendVolumeBracket: null,
                unitVolume: 58,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 6006.5,
                spendVolumeBracket: null,
                unitVolume: 58,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 6,
              excludedPlannedSpend: {
                spendVolume: 3745.5,
                spendVolumeBracket: null,
                unitVolume: 56,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 1725,
                spendVolumeBracket: null,
                unitVolume: 2,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 2657.5,
              savingsPct: 7,
              plannedSpend: {
                spendVolume: 31923.1,
                spendVolumeBracket: null,
                unitVolume: 137,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 34580.6,
                spendVolumeBracket: null,
                unitVolume: 137,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 19,
              excludedPlannedSpend: {
                spendVolume: 18968.1,
                spendVolumeBracket: null,
                unitVolume: 132,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 12955,
                spendVolumeBracket: null,
                unitVolume: 5,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9429767294,
          name: 'Access / Dual 90',
          seller: {
            name: 'DePuy Synthes Co',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9459898955,
          name: 'Access / 80% MS',
          seller: {
            name: 'Stryker Orthopaedics',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: -710,
              savingsPct: -1,
              plannedSpend: {
                spendVolume: 56010,
                spendVolumeBracket: null,
                unitVolume: 68,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 55300,
                spendVolumeBracket: null,
                unitVolume: 68,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 27,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 56010,
                spendVolumeBracket: null,
                unitVolume: 68,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 7554,
                spendVolumeBracket: null,
                unitVolume: 3,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 7554,
                spendVolumeBracket: null,
                unitVolume: 3,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 3,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 7554,
                spendVolumeBracket: null,
                unitVolume: 3,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9393501713,
          name: 'Access / 80% MS',
          seller: {
            name: 'Exactech US, Inc.',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 6787.31,
              savingsPct: 7,
              plannedSpend: {
                spendVolume: 81231,
                spendVolumeBracket: null,
                unitVolume: 109,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 88018.31,
                spendVolumeBracket: null,
                unitVolume: 109,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 40,
              excludedPlannedSpend: {
                spendVolume: 2114,
                spendVolumeBracket: null,
                unitVolume: 17,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 79117,
                spendVolumeBracket: null,
                unitVolume: 92,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 2988.35,
              savingsPct: 6,
              plannedSpend: {
                spendVolume: 46632.9,
                spendVolumeBracket: null,
                unitVolume: 44,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 49621.25,
                spendVolumeBracket: null,
                unitVolume: 44,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 30,
              excludedPlannedSpend: {
                spendVolume: 888,
                spendVolumeBracket: null,
                unitVolume: 9,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 45744.9,
                spendVolumeBracket: null,
                unitVolume: 35,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 23149.05,
              savingsPct: 4,
              plannedSpend: {
                spendVolume: 480446.25,
                spendVolumeBracket: null,
                unitVolume: 738,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 503595.3,
                spendVolumeBracket: null,
                unitVolume: 738,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 90,
              excludedPlannedSpend: {
                spendVolume: 19136,
                spendVolumeBracket: null,
                unitVolume: 174,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 461310.25,
                spendVolumeBracket: null,
                unitVolume: 564,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9401906988,
          name: 'Access / Dual 90',
          seller: {
            name: 'DJO Surgical',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 1722.4,
              savingsPct: 5,
              plannedSpend: {
                spendVolume: 27396.6,
                spendVolumeBracket: null,
                unitVolume: 32,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 29119,
                spendVolumeBracket: null,
                unitVolume: 32,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 18,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 27396.6,
                spendVolumeBracket: null,
                unitVolume: 32,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9401923337,
          name: 'Access/ Dual 90%',
          seller: {
            name: 'Smith & Nephew, Inc.',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 71346.89,
              savingsPct: 18,
              plannedSpend: {
                spendVolume: 306980,
                spendVolumeBracket: null,
                unitVolume: 608,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 378326.89,
                spendVolumeBracket: null,
                unitVolume: 608,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 28,
              excludedPlannedSpend: {
                spendVolume: 6970,
                spendVolumeBracket: null,
                unitVolume: 110,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 300010,
                spendVolumeBracket: null,
                unitVolume: 498,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 7824.64,
              savingsPct: 17,
              plannedSpend: {
                spendVolume: 36495,
                spendVolumeBracket: null,
                unitVolume: 69,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 44319.64,
                spendVolumeBracket: null,
                unitVolume: 69,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 21,
              excludedPlannedSpend: {
                spendVolume: 780,
                spendVolumeBracket: null,
                unitVolume: 12,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 35715,
                spendVolumeBracket: null,
                unitVolume: 57,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 9393458569,
          name: 'Access/ Dual 90%',
          seller: {
            name: 'Arthrex Inc',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 9488.15,
              savingsPct: 3,
              plannedSpend: {
                spendVolume: 232771.45,
                spendVolumeBracket: null,
                unitVolume: 187,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 242259.6,
                spendVolumeBracket: null,
                unitVolume: 187,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 71,
              excludedPlannedSpend: {
                spendVolume: 13805,
                spendVolumeBracket: null,
                unitVolume: 41,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 218966.45,
                spendVolumeBracket: null,
                unitVolume: 146,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 8095.12,
              savingsPct: 3,
              plannedSpend: {
                spendVolume: 234090.28,
                spendVolumeBracket: null,
                unitVolume: 215,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 242185.4,
                spendVolumeBracket: null,
                unitVolume: 215,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 83,
              excludedPlannedSpend: {
                spendVolume: 13315,
                spendVolumeBracket: null,
                unitVolume: 37,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 220775.28,
                spendVolumeBracket: null,
                unitVolume: 178,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
    ],
  },
  extensions: null,
  dataPresent: true,
};
